import React from "react";
import { Link } from "react-router-dom";
import "./Style.scss";
import hero from "../../../Assets/Images/hero_trading.svg";

const Header = () => {
  return (
    <section className="homeHero">
      <div className="homeHero__atmosphere" aria-hidden="true" />
      <div className="homeHero__inner">
        <div className="homeHero__copy">
          <p className="homeBrand homeHero__brand">Algoquant Global</p>
          <h1 className="homeHero__title">
            A Broking Partner for Modern Traders
          </h1>
          <p className="homeHero__disc">
            Built for clarity, speed, and simplicity — open your trading and
            demat account and start investing with confidence.
          </p>
          <div className="homeHero__actions">
            <Link to="/step-by-step" className="homeCtaPrimary">
              Open a Trading Account
              <i className="fas fa-arrow-right" aria-hidden="true" />
            </Link>
            <Link to="/contact" className="homeCtaGhost">
              Contact Us
            </Link>
          </div>
        </div>
        <div className="homeHero__visual">
          <img
            src={hero}
            alt="Algoquant Global trading platform illustration"
            className="homeHero__img"
          />
        </div>
      </div>
    </section>
  );
};

export default Header;
